
document.addEventListener("DOMContentLoaded", function () {
    // -------------------------------
    // Modal and Customer Type Setup
    // -------------------------------
    const modal = document.getElementById("customer-type-modal");
    const buttons = document.querySelectorAll(".select-type");
    const dropdown = document.getElementById("customer-type-switch");

    function setCookie(name, value, days) {
        let expires = "";
        if (days) {
            const date = new Date();
            date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
            expires = "; expires=" + date.toUTCString();
        }
        document.cookie = name + "=" + value + "; path=/; SameSite=Lax" + expires;
    }

    function getCookie(name) {
        const cookies = document.cookie.split("; ");
        for (let i = 0; i < cookies.length; i++) {
            const [key, value] = cookies[i].split("=");
            if (key === name) {
                return value;
            }
        }
        return null;
    }

    // Show modal only if no cookie exists.
    if (!getCookie("med_moms")) {
        modal.style.display = "flex";
    }

    // When user clicks a selection button in the modal.
    buttons.forEach(button => {
        button.addEventListener("click", function () {
            const type = this.dataset.type;
            const value = type === "privat" ? "true" : "false";
            setCookie("med_moms", value, 30);
            modal.style.display = "none";
            if (dropdown) {
                dropdown.value = type;
            }
            updatePrices();
        });
    });

    // Handle dropdown changes.
    if (dropdown) {
        dropdown.addEventListener("change", function () {
            const type = this.value;
            const value = type === "privat" ? "true" : "false";
            setCookie("med_moms", value, 30);
            updatePrices();
        });

        // Set dropdown value based on cookie on load.
        const savedType = getCookie("med_moms");
        if (savedType !== null) {
            dropdown.value = savedType === "true" ? "privat" : "erhverv";
        }
    }

    // -------------------------------
    // Variant Change Listener
    // -------------------------------
    // When the variant changes, we simply trigger an update without deleting our cached privat prices.
    const variantSelector = document.getElementById("option1");
    if (variantSelector) {
        variantSelector.addEventListener("change", function () {
            // Allow Shopify time to re‑render the markup.
            setTimeout(() => {
                updatePrices();
            }, 350);
        });
    }

    // -------------------------------
    // Quantity Change Listener (Cart)
    // -------------------------------
    // Using event delegation to catch changes on quantity inputs anywhere in the document.
    document.addEventListener("change", function (e) {
        if (e.target.matches("input[name='quantity']")) {
            const cartItem = e.target.closest(".cart__form-item, .quick-cart__item");
            if (cartItem) {
                const priceElement = cartItem.querySelector(".product-price-value, [data-price]");
                if (priceElement) {
                    // We do not delete the cached privat price here either.
                }
            }
            updatePrices();
        }
    });

    // Initial update on load.
    updatePrices();

    // -------------------------------
    // MutationObserver for Dynamic Changes
    // -------------------------------
    let debounceTimeout;
    const observer = new MutationObserver(function (mutationsList) {
        if (debounceTimeout) {
            clearTimeout(debounceTimeout);
        }
        debounceTimeout = setTimeout(() => {
            updatePrices();
        }, 100);
    });
    observer.observe(document.body, { childList: true, subtree: true });
});


// -------------------------------
// Helper Functions
// -------------------------------

function formatPrice(price, isErhverv, isHeader = false, isQuickCart = false) {
    let formattedPrice = new Intl.NumberFormat("da-DK", {
        style: "currency",
        currency: "DKK",
        minimumFractionDigits: 2
    }).format(price);

    if (isQuickCart) {
        return isErhverv ? formattedPrice + " ekskl. moms" : formattedPrice;
    }
    if (isHeader) {
        return isErhverv ? formattedPrice + " uden moms" : formattedPrice;
    }
    return isErhverv ? formattedPrice + " ekskl. moms" : formattedPrice;
}

function extractBasePrice(text) {
    // Matches numbers such as "6.359,22", "231,69" or "231"
    let match = text.match(/(\d{1,3}(?:\.\d{3})*(?:,\d+)?|\d+(?:,\d+)?)/);
    if (match) {
        let numStr = match[0];
        if (numStr.indexOf(",") !== -1) {
            numStr = numStr.replace(/\./g, '').replace(",", ".");
        }
        return parseFloat(numStr);
    }
    return NaN;
}

/**
 * getPrivatPrice(element)
 * Returns the original (privat) price for a price element.
 * Priority:
 * 1. If the element has a data-original-base-price attribute, use it.
 * 2. If a cached value exists in dataset.privatPrice, use that.
 * 3. Otherwise, extract the price from the element’s inner text and cache it.
 * 
 * If the newly extracted number is higher (by more than a small tolerance) than the stored value,
 * then update the cached value. This helps when Shopify re‑renders a new variant with a higher privat price.
 */
function getPrivatPrice(element) {
    let privat = NaN;
    // Check if Shopify provided an original base price attribute.
    let attr = element.getAttribute('data-original-base-price');
    if (attr) {
        privat = parseFloat(attr.replace(',', '.'));
        if (!isNaN(privat)) {
            element.dataset.privatPrice = privat;
            return privat;
        }
    }
    // Check if a privat price is already cached.
    if (element.dataset.privatPrice) {
        let cached = parseFloat(element.dataset.privatPrice);
        // See if the current displayed text has a higher number (assume a new variant's privat price)
        let current = extractBasePrice(element.textContent);
        // Allow a small tolerance to account for formatting differences.
        if (!isNaN(current) && current > cached + 0.05) {
            element.dataset.privatPrice = current;
            return current;
        }
        return cached;
    }
    // Otherwise, extract from the element's text and cache it.
    privat = extractBasePrice(element.textContent);
    element.dataset.privatPrice = privat;
    return privat;
}

// -------------------------------
// Cart Totals Update (Read Totals from DOM)
// -------------------------------
function updateCartTotals(isErhverv) {
    const cartElements = [
        { selector: ".cart__footer-subtotal .product-price-value", isHeader: false, isQuickCart: false },
        { selector: ".quick-cart__footer-subtotal span", isHeader: false, isQuickCart: true },
        { selector: ".header__cart-link .header__icon-with-label-touch-label", isHeader: true, isQuickCart: false }
    ];

    cartElements.forEach(item => {
        const element = document.querySelector(item.selector);
        if (element) {
            let privat;
            // Try to use the data-original-base-price attribute if available.
            let attr = element.getAttribute('data-original-base-price');
            if (attr) {
                privat = parseFloat(attr.replace(',', '.'));
                element.dataset.privatPrice = privat;
            } else {
                privat = getPrivatPrice(element);
            }
            if (!isNaN(privat)) {
                let newTotal = isErhverv ? privat * 0.8 : privat;
                if (item.isHeader) {
                    element.textContent = formatPrice(newTotal, isErhverv, true);
                } else if (item.isQuickCart) {
                    element.innerHTML = formatPrice(newTotal, isErhverv, false, true);
                } else {
                    element.innerHTML = formatPrice(newTotal, isErhverv);
                }
            }
        }
    });
}

// -------------------------------
// Main Update Function
// -------------------------------
function updatePrices() {
    const isErhverv = getCookie("med_moms") === "false";

    // -------------------------------
    // Update Main Price Elements
    // -------------------------------
    const mainPriceElements = document.querySelectorAll(".product-price-value, [data-price]");
    mainPriceElements.forEach(priceElement => {
        // Skip a container that already holds individual child elements.
        if (priceElement.classList.contains("product-item__price-main")) {
            if (priceElement.querySelector(".compare-price-value") && priceElement.querySelector(".sale.product-price-value")) {
                return;
            }
        }
        // Preserve any prefix (e.g. "fra ") if present.
        if (!priceElement.dataset.originalPrefix) {
            const originalText = priceElement.textContent.trim();
            const match = originalText.match(/^(fra\s+)/i);
            priceElement.dataset.originalPrefix = match ? match[0] : "";
        }
        let privat = getPrivatPrice(priceElement);
        if (!isNaN(privat)) {
            const newPrice = isErhverv ? privat * 0.8 : privat;
            priceElement.innerHTML = priceElement.dataset.originalPrefix + formatPrice(newPrice, isErhverv);
        }
    });

    // -------------------------------
    // Update Compare Price Elements
    // -------------------------------
    const comparePriceElements = document.querySelectorAll(".compare-price-value, [data-compare-price]");
    comparePriceElements.forEach(comparePriceElement => {
        let privat = getPrivatPrice(comparePriceElement);
        if (!isNaN(privat)) {
            const newPrice = isErhverv ? privat * 0.8 : privat;
            comparePriceElement.innerHTML = formatPrice(newPrice, isErhverv);
        }
    });

    // Update cart totals.
    updateCartTotals(isErhverv);
}

// Helper: Get cookie (duplicated for updatePrices scope)
function getCookie(name) {
    const cookies = document.cookie.split("; ");
    for (let i = 0; i < cookies.length; i++) {
        const parts = cookies[i].split("=");
        if (parts[0] === name) {
            return parts[1];
        }
    }
    return null;
}

